/**
 * This is a helper function that allows us to use async/await with promises
 * that may throw errors. It lets us avoid the try/catch tower of terror.
 * The result is Golang style error handling. Runs the given async function
 * around a try/catch block.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "promiseResolver", {
    enumerable: true,
    get: function() {
        return promiseResolver;
    }
});
const promiseResolver = async (promise)=>{
    try {
        const data = await promise;
        return [
            data,
            null
        ];
    } catch (throwable) {
        if (throwable instanceof Error) return [
            null,
            throwable
        ];
        throw throwable;
    }
};
